export default "__VITE_ASSET__er5PbtTB__"